/* eslint-disable global-require */
import RegexUtils from '../utils/RegexUtils';
// https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#migrate-to-using-native-intl-apis
// Use polyfill for browsers that do not have Intl.PluralRules (e.g IE11 & Safari 12-)
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/dist/locale-data/en');
  require('@formatjs/intl-pluralrules/dist/locale-data/fr');
}
// Use polyfill for browsers that do not have Intl.RelativeTimeFormat (e.g IE11, Edge, Safari 13-)
if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/fr');
}

// ISO country codes: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
const FR_LOCALE = {
  matchingPattern: RegexUtils.browserLocalesFr,
  locale: 'fr-FR',
  language: 'fr',
  countryCode: 'FR',
  desc: 'Français',
};

const EN_LOCALE = {
  matchingPattern: RegexUtils.browserLocalesEn,
  locale: 'en-GB',
  language: 'en',
  countryCode: 'GB',
  desc: 'English',
};

const ES_LOCALE = {
  matchingPattern: RegexUtils.browserLocalesEs,
  locale: 'es-ES',
  language: 'es',
  countryCode: 'ES',
  desc: 'Español',
};

const DEFAULT_LOCALE = 'fr-FR';
const AVAILABLE_LOCALES = [
  FR_LOCALE,
  EN_LOCALE,
  ES_LOCALE,
];

const localeManager = {
  getDefaultLocale: () => AVAILABLE_LOCALES.find((localeItem) => localeItem.locale === DEFAULT_LOCALE),
  getAvailableLocales: () => (AVAILABLE_LOCALES),
  getLocale: (locale) => AVAILABLE_LOCALES.find((localeItem) => localeItem.locale === locale),
};

module.exports = localeManager;



// WEBPACK FOOTER //
// ./intl/LocalesManager.js